// extracted by mini-css-extract-plugin
module.exports = {"root":"BaseTextArea_root__2_pWP","input":"BaseTextArea_input__1_TV2","maxLength":"BaseTextArea_maxLength__1IfUO"};